import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../../services/apis";
import { Icon, Modal, Button, Header, Divider } from "semantic-ui-react";
import ReactHtmlParser from "react-html-parser";
import {
  Container,
  Content,
  Title,
  Input,
  ModalContentSubContainer,
  TestButtonsGroup,
} from "./styles";
import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../../components/Admin/MenuDetalhes/AdminMenu";
import Cke from "../../../../../../components/Cke";
import { toast } from "react-toastify";
import { systemLogs } from "../../../../../../services/system_logs";

const EditarLicoesCursos = (props) => {
  const id = props.match.params.id;
  const idCurso = props.match.params.id_curso;
  const [licoes, setLicoes] = useState([]);
  const [open, setOpen] = useState(false);
  const [licao, setLicao] = useState([]);
  const [valorIndex, setValorIndex] = useState([]);
  const [file, setFile] = useState(null);
  const [loadingLessonCreation, setLoadingLessonCreation] = useState(false);
  const [isSavingOrder, setIsSavingOrder] = useState(false);
  const [hasOrderChanged, setHasOrderChanged] = useState(false);

  const moveLicao = useCallback(
    (currentIndex, direction) => {
      const newIndex = currentIndex + direction;

      if (newIndex < 0 || newIndex >= licoes.length) {
        return;
      }

      const newLicoes = [...licoes];
      const licaoAtual = newLicoes[currentIndex];
      const outraLicao = newLicoes[newIndex];

      [newLicoes[currentIndex], newLicoes[newIndex]] = [outraLicao, licaoAtual];

      const reorderedLicoes = newLicoes.map((licao, index) => {
        let newOrdem;
        if (index === 0) {
          newOrdem = 0; 
        } else if (index === 1) {
          newOrdem = 2; 
        } else {
          newOrdem = index + 1; 
        }
        return {
          ...licao,
          ordem: newOrdem,
        };
      });

      setLicoes(reorderedLicoes);
      setHasOrderChanged(true);
    },
    [licoes]
  );

  const handleConfirmarOrdem = useCallback(async () => {
    setIsSavingOrder(true);
    swal("Salvando nova ordem...", {
      buttons: false,
      timer: 2000,
    });

    const bulkUpdatePayload = licoes.map(licao => ({
      id: licao.id,
      ordem: licao.ordem,
    }));

    try {
      await api.put(`admin/licoes/bulk-update-order`, bulkUpdatePayload);
      
      swal("Sucesso!", "A ordem das lições foi atualizada.", "success");
      setHasOrderChanged(false);
    } catch (error) {
      console.error("Erro ao atualizar ordem:", error);
      swal("Erro", "Ocorreu um erro ao salvar a ordem das lições.", "error");
      loadLicoes(); 
    } finally {
      setIsSavingOrder(false);
    }
  }, [licoes]);

  const uploadAnexo = useCallback(async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", file);
      inputData.append("path", "licoes-anexos");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setLicao((licao) => ({ ...licao, anexo: url }));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [file]);

  const loadLicoes = () => {
    api
      .get(`/admin/licoes/modulo/${id}`, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then((res) => {
        const newLicoes = res.data.licoes;

        newLicoes.sort((a, b) => a.ordem - b.ordem);

        setLicoes(newLicoes);
        setHasOrderChanged(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar as lições", err, "");
      });
  };

  const loadLicao = async (id) => {
    try {
      const res = await api.get(`/licao_simples/${id}`, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      });

      setLicao({ ...res.data.licao, ativo: res.data.licao.ativo ? 1 : 0 });

      await systemLogs("curso", "listou as lições");
    } catch (err) {
      console.error(err);

      swal(
        "Não foi possível carregar a lição",
        "Inconsitencia de dados",
        "error"
      );
    }
  };

  const removeLicao = useCallback(
    (id) => {
      swal("Tem certeza ?", "Você quer deletar esta lição ?", "warning").then(
        (res) => {
          if (!res) {
            return;
          }
          api
            .delete(`admin/licao/${id}`, {
              headers: {
                access_token: `voitto-token ${localStorage.getItem(
                  "oauth_token"
                )}`,
              },
            })
            .then(async () => {
              let logs = {
                local: "curso",
                texto: `deletou a licao de id=${id} do curso de id=${idCurso}`,
              };
              api.post("system_logs", { acao: JSON.stringify(logs) });
              const newLicoes = [...licoes].filter((licao) => licao.id !== id);
              setLicoes(newLicoes);
              swal("Lição deletada com sucesso", "", "success");
            })
            .catch((err) => {
              swal("Não foi possível deletar a lição", err, "");
            });
        }
      );
    },
    [licoes]
  );

  const modifyLicoes = useCallback(async () => {
    const payload = {
      ordem: licao.ordem,
      id_modulo: licao.id_modulo,
      id_curso: licao.id_curso,
      titulo: licao.titulo,
      tipo: licao.tipo,
      anexo: `${licao.tipo}://${licao.anexo.split("://").pop()}`,
      opcional: parseInt(licao.opcional) === 1,
      ativo: parseInt(licao.ativo) === 1,
      // dependencia: licao.dependencia,
      video_alternativo: licao.video_alternativo,
      libera_data: licao.libera_data,
      descricao: licao.descricao,
      duracao: licao.duracao,
    };

    await api
      .put(`admin/licao/${licao.id}`, payload)
      .then((res) => {
        swal("A lição foi atualizada com sucesso", "", "success");
      })
      .catch((err) => {
        swal("Não foi possível carregar a lição", err, "");
      });
    const newLicoes = licoes;

    newLicoes[valorIndex] = { ...licao };
    setLicoes([...newLicoes]);
  }, [licoes, licao]);

  const getTesteByJSID = useCallback(async (js_id) => {
    try {
      const { teste } = (await api.get(`testes/js-id/${js_id}`)).data;

      return teste;
    } catch (err) {
      return null;
    }
  }, []);

  const handleCreateTeste = useCallback(async () => {
    window.open(`/admin/ead/testes/criar?id_licao=${licao.id}`);
  }, [licao]);

  const handleUpdateTeste = useCallback(async () => {
    if (!licao.anexo.includes("teste://")) {
      return;
    }

    const js_id = licao.anexo.replace("teste://", "");
    const teste = await getTesteByJSID(js_id);

    if (!teste) {
      return;
    }

    window.open(`/admin/ead/testes/${teste.id}?id_licao=${licao.id}`, "_blank");
    handleSelectTest();
  }, [licao]);

  const handleSearchTeste = useCallback(async () => {
    window.open(`/admin/ead/testes?id_licao=${licao.id}`);
  }, [licao]);

  const handleCreateLesson = async () => {
    const initialPayload = {
      ordem: licoes?.length ? licoes.length + 1 : 0,
      id_modulo: id,
      id_curso: idCurso,
      titulo: "A Definir",
      tipo: "youtube",
      anexo: "",
      opcional: 0,
      ativo: 0,
      video_alternativo: "",
      libera_data: new Date(),
      descricao: "",
      duracao: 0,
    };

    try {
      setLoadingLessonCreation(true);

      const res = await api.post(`admin/licao`, initialPayload);

      await loadLicao(res.data.verfyCreation?.id);
      setOpen(true);
      setValorIndex(licoes?.length ? licoes.length : 0);
      loadLicoes();
    } catch (error) {
      console.log(error);
      swal(
        "Houve um erro ao tentar criar a lição, contate TI para verificar o problema"
      );
    } finally {
      setLoadingLessonCreation(false);
    }
  };

  useEffect(() => {
    loadLicoes();
  }, []);

  const handleSelectTest = () => {
    modifyLicoes();
    setOpen(false);
  };

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Cursos - lições</Title>
          <div>
            <Button
              loading={loadingLessonCreation}
              color="grey"
              onClick={handleCreateLesson}
            >
              Criar
            </Button>
            <Button
              loading={isSavingOrder}
              color="grey"
              onClick={handleConfirmarOrdem}
              disabled={!hasOrderChanged || isSavingOrder}
            >
              Salvar edição da ordem
            </Button>
          </div>
          <div>
            <h3>Editar Lições</h3>

            {licoes == null
              ? "Não tem lições"
              : licoes.map((licao, index) => (
                  <div
                    key={licao.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <div style={{ marginRight: "10px" }}>
                      <Button
                        icon
                        size="mini"
                        style={{ backgroundColor: "#767676", color: "white" }}
                        onClick={() => moveLicao(index, -1)}
                        disabled={index === 0}
                      >
                        <Icon name="arrow up" />
                      </Button>
                      <Button
                        icon
                        size="mini"
                        style={{ backgroundColor: "#767676", color: "white" }}
                        onClick={() => moveLicao(index, 1)}
                        disabled={index === licoes.length - 1}
                      >
                        <Icon name="arrow down" />
                      </Button>
                    </div>
                    <label style={{ flexGrow: 1 }}>
                      Titulo:{ReactHtmlParser(licao.titulo)}
                    </label>
                    <Button
                      floated="right"
                      icon
                      color="yellow"
                      onClick={() => {
                        loadLicao(licao.id);
                        setOpen(true);
                        setValorIndex(index);
                      }}
                    >
                      <Icon name="edit" />
                      Editar lição
                    </Button>
                    <Button
                      floated="right"
                      icon
                      color="red"
                      onClick={() => removeLicao(licao.id)}
                    >
                      <Icon name="remove" color="white" />
                    </Button>
                    <Divider />
                  </div>
                ))}
          </div>
        </Content>
      </Container>

      <Modal
        closeIcon
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        closeOnDimmerClick={false}
      >
        <Header icon="edit" content="Editar Lição" />
        <Modal.Content>
          <ModalContentSubContainer>
            <label>
              Titulo:
              <Input
                type="text"
                value={licao.titulo}
                onChange={(e) => setLicao({ ...licao, titulo: e.target.value })}
              />
            </label>
            <label>
              Tipo:
              <select
                id="tipo"
                onChange={(e) => setLicao({ ...licao, tipo: e.target.value })}
                value={licao.tipo}
              >
                <option value="apresentacao">📎 Apresentação de Slides</option>
                <option value="arquivo">📄 Arquivo</option>
                <option value="file-sender">
                  🔗 📄 Envio de Arquivo (Pelo aluno)
                </option>
                <option value="feedback">💬 Feedback do Couch</option>
                <option value="embed">💻 Incorporar</option>
                <option value="linkYT">🔗🎬 Link para vídeo do Youtube</option>
                <option value="link">🔗 Link</option>
                <option value="expectativa">🔍 Pesquisa de Expectativa</option>
                <option value="pesquisa">📈 Pesquisa de Satisfação</option>
                <option value="teste">💬 Teste - teste</option>
                <option value="aovivo">📡 Transmissão Ao Vivo</option>
                <option value="video">🎬 Vídeo</option>
                <option value="youtube">🎬 Vídeo do Youtube</option>
                <option value="youtubelive">📡 Live do Youtube</option>
                <option value="manualbordo">💬 Manual de Bordo </option>
                <option value="certificado"> Certificado Interno </option>
                <option value="form_mba">📄 Forms MBA </option>
              </select>
            </label>

            <label>
              Anexo:
              <Input
                type="text"
                value={licao.anexo}
                onChange={(e) => setLicao({ ...licao, anexo: e.target.value })}
              />
            </label>

            {licao.tipo === "teste" && (
              <TestButtonsGroup>
                <label>
                  <Button
                    as="a"
                    target="_blank"
                    href={`/admin/ead/testes/criar?id_licao=${licao.id}`}
                    onClick={handleSelectTest}
                  >
                    Criar
                  </Button>
                </label>

                {licao.anexo.includes("teste://") && (
                  <label>
                    <Button onClick={handleUpdateTeste}>Editar</Button>
                  </label>
                )}

                <label>
                  <Button
                    as="a"
                    target="_blank"
                    href={`/admin/ead/testes?id_licao=${licao.id}`}
                    onClick={handleSelectTest}
                  >
                    Procurar
                  </Button>
                </label>
              </TestButtonsGroup>
            )}

            <label>
              <span> Arquivo do Anexo: </span>

              <Input
                readOnly={true}
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
                placeholder={"URL do arquivo"}
              />

              <Button type="button" onClick={uploadAnexo}>
                Upload
              </Button>
            </label>

            <label>
              Video Alternativo:
              <Input
                type="text"
                value={licao.video_alternativo}
                onChange={(e) =>
                  setLicao({ ...licao, video_alternativo: e.target.value })
                }
              />
            </label>
            <label>Descrição:</label>
            <Cke
              default={licao.descricao}
              onBlur={(value) => setLicao({ ...licao, descricao: value })}
            />

            <label>
              <span>Duração (minutos):</span>
              <Input
                type="number"
                value={licao.duracao}
                onChange={(e) =>
                  setLicao({ ...licao, duracao: e.target.value })
                }
              />
            </label>

            <label>
              Data de Liberação:
              <Input
                type="datetime"
                value={licao.libera_data}
                onChange={(e) =>
                  setLicao({ ...licao, libera_data: e.target.value })
                }
              />
            </label>

            <label>
              Ordem:
              <Input
                type="text"
                value={licao.ordem}
                onChange={(e) => setLicao({ ...licao, ordem: e.target.value })}
              />
            </label>
            <label>
              Liberado:
              <select
                value={parseInt(licao.ativo)}
                onChange={(e) => setLicao({ ...licao, ativo: e.target.value })}
              >
                <option value={0}> Trancado </option>
                <option value={1}> Liberado </option>
              </select>
            </label>
            <label>
              É opcional ?
              <select
                value={parseInt(licao.opcional)}
                onChange={(e) =>
                  setLicao({ ...licao, opcional: e.target.value })
                }
              >
                <option value={1}> Sim </option>
                <option value={0}> Não </option>
              </select>
            </label>
          </ModalContentSubContainer>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setOpen(false)}>
            <Icon name="remove" /> No
          </Button>
          <Button
            color="green"
            onClick={() => {
              modifyLicoes();
              setOpen(false);
            }}
          >
            <Icon name="checkmark" /> Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default withRouter(EditarLicoesCursos);
